const CopyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1979_181197)">
        <path
          d="M22.2212 0H8.95488C8.00938 0 7.24023 0.7692 7.24023 1.71464V5.73903H8.80545V1.71464C8.80545 1.63226 8.8725 1.56522 8.95488 1.56522H22.2212C22.3036 1.56522 22.3707 1.63226 22.3707 1.71464V14.981C22.3707 15.0634 22.3036 15.1305 22.2212 15.1305H18.3223V16.6957H22.2212C23.1667 16.6957 23.9359 15.9265 23.9359 14.981V1.71464C23.9358 0.7692 23.1667 0 22.2212 0Z"
          fill="#5E5E5E"
        />
        <path
          d="M15.0435 7.30664H1.7772C0.8317 7.30664 0.0625 8.07584 0.0625 9.02134V22.2877C0.0625522 23.2332 0.8317 24.0024 1.7772 24.0024H15.0436C15.9891 24.0024 16.7583 23.2332 16.7583 22.2878V9.02134C16.7583 8.07584 15.989 7.30664 15.0435 7.30664ZM15.0436 22.4372H1.7772C1.69476 22.4372 1.62772 22.3701 1.62772 22.2878V9.02134C1.62772 8.9389 1.69476 8.87186 1.7772 8.87186H15.0436C15.126 8.87186 15.193 8.9389 15.193 9.02134V22.2878H15.1931C15.1931 22.3701 15.126 22.4372 15.0436 22.4372Z"
          fill="#5E5E5E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1979_181197">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CopyIcon;
